import { render, staticRenderFns } from "./popup-settings.vue?vue&type=template&id=553e8e70&scoped=true&"
import script from "./popup-settings.vue?vue&type=script&lang=js&"
export * from "./popup-settings.vue?vue&type=script&lang=js&"
import style0 from "./popup-settings.vue?vue&type=style&index=0&id=553e8e70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e8e70",
  null
  
)

export default component.exports